import React from 'react';
import { Input, Button, Select } from 'components';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants } from 'utils';
import { ConsultationPlanService } from 'services';
import moment from 'moment';
import {
	Home1Icon,
	Home2Icon,
	Home3Icon,
	Home4Icon,
	TrashIcon
} from 'assets/icons';
import { 
	SelectPlan,
	MessagesImage,
	MessagesImage2,
	PlanImage,
	CalendarImage,
	NoPlanImage
} from 'assets/img';
import { connect } from 'react-redux';

interface Props extends RootState {
	onClose?: any;
	user_id?: number | null;
}

class SelectConsultationPlanComponent extends React.Component<Props> {

	state = {
		plans: [],
		plan_users: [],
		loading: true,
		visible: false,
		consultations_remaining: 0,
		total_consultations: 0,
		dates: [],
		plans_selected: [],
		actual_plan: null,
		conversion: 0,
		iva: 0,
		phone_codes: Constants.PHONECODES,
		bnc_document: '',
		bnc_bank: '',
		bnc_phone: '',
		banks: [],
		form: {
			phone_code: '412',
			phone: '',
			reference: '',
			bank_code: ''
		},
	}

	componentDidMount() {
		this.load();
	}

	load = async () => {
		await this.setState({
			dates: [],
			plans: []
		});
		const res: any = await ConsultationPlanService.admin.getPlanList({
			user_id: this.props.user_id
		});
		let dates: any = [...this.state.dates];
		let plans: any = [...this.state.plans];

		for (let i = 0; i < res.plan_users.length; i++) {
			if (plans.map((i: any) => i.id).indexOf(res.plan_users[i].plan_id) == -1) {
				plans.push({
					id: res.plan_users[i].plan_id,
					name: res.plan_users[i].plan?.name || ''
				});
			}

			const index = dates.map((i: any) => i.expiration_date).indexOf(res.plan_users[i].expiration_date);
			if (index == -1) {
				dates.push({
					expiration_date: res.plan_users[i].expiration_date,
					consultations_remaining: res.plan_users[i].consultations_remaining,
					plans: [{
						id: res.plan_users[i]?.id,
						plan_id: res.plan_users[i].plan_id,
						name: res.plan_users[i].plan?.name,
						consultations_remaining: res.plan_users[i].consultations_remaining
					}]
				});
			}
			else {
				dates[index] = {
					...dates[index],
					consultations_remaining: dates[index].consultations_remaining + res.plan_users[i].consultations_remaining,
					plans: [...dates[index].plans,{
						id: res.plan_users[i]?.id,
						plan_id: res.plan_users[i].plan_id,
						name: res.plan_users[i].plan?.name,
						consultations_remaining: res.plan_users[i].consultations_remaining
					}]
				}
			}
		}
		this.setState({
			plans: res.plans || [],
			plan_users: res.plan_users || [],
			loading: false,
			consultations_remaining: res.consultations_remaining,
			total_consultations: res.total_consultations,
			dates,
			plans_selected: plans,
			actual_plan: res.actual_plan,
			bnc_phone: res.bnc_phone || '',
			bnc_bank: res.bnc_bank || '',
			bnc_document: res.bnc_document || '',
			banks: res.banks || [],
			conversion: res.conversion || 0,
			iva: res.iva || 0
		});
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	setActive = (item: any, index: number) => {
		if (this.props.user?.level_id == Constants.LEVELS.CLIENT) {
			return;
		}

		let plans: any = [...this.state.plans].map((item: any) => {
			item.active = false;
			return item;
		});
		plans[index].active = !plans[index].active;
		this.setState({
			plans
		});
	}

	submit = async () => {
		const plan: any = this.state.plans.find((item: any) => item.active);

		if (this.props.user?.level_id == Constants.LEVELS.CLIENT) {
			if (!this.state.form.bank_code) {
				Globals.showError('Por favor, ingrese el banco emisor');
				return;
			}

			if (!this.state.form.phone_code) {
				Globals.showError('Por favor, ingrese el código de teléfono');
				return;
			}

			if (!this.state.form.phone) {
				Globals.showError('Por favor, ingrese el número de teléfono');
				return;
			}

			if (!this.state.form.reference) {
				Globals.showError('Por favor, ingrese el número de referencia');
				return;
			}

			await ConsultationPlanService.savePlan({
				plan_id: plan?.id,
				...this.state.form
			});
			Globals.showSuccess("Se ha pagado el plan correctamente");
		}
		else {
			await ConsultationPlanService.admin.saveUser({
				plan_id: plan?.id,
				to_user_id: this.props.user_id
			});
			Globals.showSuccess("Se ha modificado el plan");
		}

		this.load();
	}

	deletePlan = (e: any, item: any) => {
		e.preventDefault();
		Globals.confirm('¿Desea eliminar las consultas seleccionados?',async () => {
			await ConsultationPlanService.admin.deletePlanUser({
				plan_user_id: item?.id
			});
			Globals.showSuccess("Se han eliminado las consultas del usuario");
			this.load();
		});
	}
	
	render() {
		const plan: any = this.state.plans.find((item: any) => item.active);
		const { dates, plans_selected, loading } = this.state;
		const actual_plan: any = this.state.actual_plan;

		return (
			<div id="modal-view-plans">
				{
					!loading && (
						<div className="row row-plan">
							<div className="col-md-6">
								<div className="item black">
									<div className="container-icon">
										<img src={ Home1Icon } />
										<p className="name">Consultas restantes</p>
									</div>
									<div className="value">
										<p>{ this.state.consultations_remaining }</p>
									</div>
									<img src={ MessagesImage } className="principal-image" />
								</div>
							</div>
							<div className="col-md-6">
								<div className="item blue">
									<div className="container-icon">
										<img src={ Home2Icon } />
										<p className="name">Consultas totales</p>
									</div>
									<div className="value">
										<p>{ this.state.total_consultations }</p>
									</div>
									<img src={ MessagesImage2 } className="principal-image" />
								</div>
							</div>
							<div className="col-md-6">
								<div className="item violet">
									<div className="container-icon">
										<img src={ Home3Icon } />
										<p className="name">Plan Seleccionado</p>
									</div>
									<div className="value small">
										<p>{ actual_plan?.plan?.name }</p>
									</div>
									<img src={ PlanImage } className="principal-image" />
								</div>
							</div>
							<div className="col-md-6">
								<div className="item green">
									<div className="container-icon">
										<img src={ Home4Icon } />
										<p className="name">Fecha de vencimiento</p>
									</div>
									{
										dates.map((item: any) => {
											return (
												<div className="value small">
													<p>{ moment(item?.expiration_date).format('DD/MM/YYYY') } ({ item?.consultations_remaining })</p>
													<ul>
														{
															item.plans.map((i: any) => {
																return (
																	<li>
																		<p>{ i.name } ({ i.consultations_remaining })</p>
																		{
																			this.props.user?.level_id != Constants.LEVELS.CLIENT && (
																				<a className="link-icon link-red" href="#" onClick={ (e: any) => this.deletePlan(e,i) }>
																					<img src={ TrashIcon } className="delete-plan" />
																				</a>
																			)
																		}
																	</li>
																)
															})
														}
													</ul>
												</div>
											)
										})
									}
									<img src={ CalendarImage } className="principal-image" />
								</div>
							</div>
						</div>
					)
				}

				{
					this.props.user?.level_id != Constants.LEVELS.CLIENT && (
						<>
							<h1>{ this.props.user?.level_id != Constants.LEVELS.CLIENT ? 'Asignar plan' : 'Seleccionar plan' }</h1>
							<hr />
						</>
					)
				}

				<div className="row">
					{
						this.state.plans.map((item: any,index: number) => {
							return (
								<div className="col-md-4">
									<div className={ `item-plan ${ item.active ? 'active' : '' }` } onClick={ () => this.setActive(item,index) }>
										<div className="row">
											<div className="col-md-7">
												<p className="name">{ item?.name }</p>
												<p className="messages">{ item?.quantity } Consultas</p>
											</div>
											<div className="col-md-5 text-right">
												{
													this.props.user?.level_id == Constants.LEVELS.CLIENT ? (
														<>
															<p className="price">{ Globals.formatMiles((item?.price + (item?.price * (this.state.iva / 100))) * this.state.conversion,true,'Bs.') }</p>
															<p className="price-iva">{ Globals.formatMiles(item?.price * this.state.conversion,true,'Bs.') } + IVA</p>
														</>
													) : (
														<>
															<p className="price">{ Globals.formatMiles(item?.price) }</p>
															<p className="price-iva">(Sin IVA)</p>
														</>
													)
												}
											</div>
										</div>
									</div>
								</div>
							)
						})
					}
				</div>

				{
					this.props.user?.level_id == Constants.LEVELS.CLIENT && (
						<>
							<div className="payment-data">
								<p className="title"><strong>Datos de Pago</strong></p>
								<p><strong>Banco:</strong> { this.state.bnc_bank }</p>
								<p><strong>Cédula:</strong> { this.state.bnc_document }</p>
								<p><strong>Teléfono:</strong> { this.state.bnc_phone }</p>
							</div>
						</>
					)
				}

				{
					plan != null && (
						<>
							{/*{
								this.props.user?.level_id == Constants.LEVELS.CLIENT && (
									<>
										<div className="payment-data">
											<p className="title"><strong>Datos de Pago</strong></p>
											<p><strong>Banco:</strong> { this.state.bnc_bank }</p>
											<p><strong>RIF:</strong> { this.state.bnc_document }</p>
											<p><strong>Teléfono:</strong> { this.state.bnc_phone }</p>
											<p><strong>Monto a pagar:</strong> { Globals.formatMiles((this.state.conversion * (plan?.price + (plan?.price * (this.state.iva / 100)))).toFixed(2),true,'Bs.') }</p>
										</div>
										<div className="row">
											<div className="col-md-6">
												<Select
													color="white"
													placeholder="Seleccionar"
													label="Banco Emisor"
													name="bank_code"
													onChange={ (e: any) => this.change(e) }
													value={ this.state.form.bank_code }
													options={ this.state.banks?.map((i: any) => {
														return {
															value: i.code,
															label: i.name
														}
													}) || [] } />
											</div>
											<div className="col-md-6">
												<p className="label">Teléfono</p>
												<div className="container-phone">
													<Select
														color="white"
														placeholder="Cód."
														name="phone_code"
														onChange={ (e: any) => this.change(e) }
														value={ this.state.form.phone_code }
														options={ Constants.PHONECODES.map((i: any) => {
															return {
																value: i.replace('0',''),
																label: i
															}
														}) || [] } />
													<Input
														maxLength={ 7 }
														type="number"
														value={ this.state.form.phone }
														name="phone"
														placeholder="Teléfono"
														onChange={ this.change } />
												</div>
											</div>
											<div className="col-md-6">
												<Input
													type="number"
													label="Número de Referencia"
													value={ this.state.form.reference }
													name="reference"
													placeholder="Referencia"
													onChange={ this.change } />
											</div>
										</div>
									</>
								)
							}*/}
							<div className="text-center">
								<Button type="submit" onClick={ () => this.submit() }>
									Continuar
								</Button>
							</div>
						</>
					)
				}
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(SelectConsultationPlanComponent);